var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcProfileCircleActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 0.8125C4.77344 0.8125 0.4375 5.14844 0.4375 10.5C0.4375 15.8516 4.77344 20.1875 10.125 20.1875C15.4766 20.1875 19.8125 15.8516 19.8125 10.5C19.8125 5.14844 15.4766 0.8125 10.125 0.8125ZM10.125 4.5625C12 4.5625 13.5625 6.125 13.5625 8C13.5625 9.91406 12 11.4375 10.125 11.4375C8.21094 11.4375 6.6875 9.91406 6.6875 8C6.6875 6.125 8.21094 4.5625 10.125 4.5625ZM10.125 18C7.82031 18 5.75 16.9844 4.38281 15.3438C5.125 13.9766 6.57031 13 8.25 13C8.32812 13 8.40625 13.0391 8.52344 13.0781C9.03125 13.2344 9.53906 13.3125 10.125 13.3125C10.6719 13.3125 11.2188 13.2344 11.6875 13.0781C11.8047 13.0391 11.8828 13 12 13C13.6406 13 15.0859 13.9766 15.8281 15.3438C14.4609 16.9844 12.3906 18 10.125 18Z",
    fill: "#283D78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileCircleActive);
export default __webpack_public_path__ + "static/media/ic-profile-circle-active.bb6aaf3910c5b7b0e2eeef43c2b16e58.svg";
export { ForwardRef as ReactComponent };